import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PhotoGrid } from "./PhotoGrid";

export const CatalogPreview = () => {
  const [photos, setPhotos] = useState([]);
  useEffect(() => {
    api.get("/photos", { params: { featured: true } }).then((r) => setPhotos(r.data.slice(0, 9))).catch(() => {});
  }, []);

  return (
    <section className="bg-[#F7EDE6]/60 py-24 sm:py-32" data-testid="catalog-preview-section">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
          <div>
            <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Catálogo</p>
            <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl" data-testid="catalog-title">Lo que ya lleva nuestra firma</h2>
          </div>
          <div className="max-w-sm">
            <p className="text-ink/70 leading-relaxed">Bodas, galas, cenas y actos que hemos tenido el gusto de dirigir. Haz clic en cualquier imagen para verla de cerca.</p>
            <Link to="/catalogo" className="mt-6 inline-flex rounded-full border border-ink/20 px-6 py-3 font-brand text-[11px] font-semibold tracking-[0.18em] uppercase hover:bg-ink hover:text-white transition-colors" data-testid="catalog-view-all-btn">Ver todo el catálogo</Link>
          </div>
        </div>
        <PhotoGrid photos={photos} testPrefix="home-catalog" />
      </div>
    </section>
  );
};
